import { render, staticRenderFns } from "./PastScriptAppointmentDetails.vue?vue&type=template&id=c348f71e"
import script from "./PastScriptAppointmentDetails.vue?vue&type=script&lang=js"
export * from "./PastScriptAppointmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports